import { useQuery } from '@tanstack/react-query';
import { fetchSpecialties, type Specialty } from '@/lib/api/specialties';

/**
 * The practitioner specialty catalogue, read from Medplum via the backend.
 *
 * Cached aggressively: it is small, changes rarely, and is fetched whenever an
 * onboarding or edit form opens.
 */
export function useSpecialties() {
  return useQuery<Specialty[]>({
    queryKey: ['specialties'],
    queryFn: fetchSpecialties,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
